export const countReturned = (element) =>
	element.value.reduce(
		(prev, next) => prev + (next.shipping.status === 'return' ? 1 : 0),
		0,
	);
